import service, { AxiosRequestConfig } from './axios'

const env = import.meta.env

export const request = <T = any>(config: AxiosRequestConfig): Promise<T> => {
  return new Promise((resolve, reject) => {
    service
      .request(config)
      .then((res: any) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const http = {
  baseUrl: '',
  get<T = any>(url: string, params = {}, config?: AxiosRequestConfig): Promise<T> {
    return request({ url: `${this.baseUrl}${url}`, params, ...config, method: 'GET' })
  },
  post<T = any>(url: string, data = {}, config?: AxiosRequestConfig): Promise<T> {
    return request({ url: `${this.baseUrl}${url}`, data, ...config, method: 'POST' })
  },
  put<T = any>(url: string, data = {}, config?: AxiosRequestConfig): Promise<T> {
    return request({ url: `${this.baseUrl}${url}`, data, ...config, method: 'PUT' })
  },
  delete<T = any>(url: string, data = {}, config?: AxiosRequestConfig): Promise<T> {
    return request({ url: `${this.baseUrl}${url}`, data, ...config, method: 'DELETE' })
  },
  patch<T = any>(url: string, data = {}, config?: AxiosRequestConfig): Promise<T> {
    return request({ url: `${this.baseUrl}${url}`, data, ...config, method: 'PATCH' })
  },
  // 上传文件，指定 'Content-Type': 'multipart/form-data'
  upload<T = any>(url: string, data = {}, config?: AxiosRequestConfig): Promise<T> {
    return request({
      url,
      data,
      ...config,
      method: 'PUT',
      headers: {
        'Content-Type': 'multipart/form-data',
        ...config?.headers
      }
    })
  }
}

export const authApi = {
  ...http,
  baseUrl: env.VITE_API_BASE_URL_AUTH
}

export const payApi = {
  ...http,
  baseUrl: env.VITE_API_BASE_URL_PAY
}

export const cmsApi = {
  ...http,
  baseUrl: env.VITE_API_BASE_URL_CMS
}

export const cdnApi = {
  ...http,
  baseUrl: env.VITE_API_BASE_URL_CDN
}

export const interactApi = {
  ...http,
  baseUrl: env.VITE_API_BASE_URL_INTERACT
}
